/*=========================================================================================
  File Name: mutations.js
  Namespace: iframes
  Description: Vuex Store - IFrame mutations
==========================================================================================*/
import {
  buildIFrameState
} from './state'

const mutations = {
  STORE_CURRENT_IFRAME(state, iframe) {
    state.currentIFrame = { ...state.currentIFrame, ...iframe }
  },
  RESET_CURRENT_IFRAME(state) {
    state.currentIFrame = buildIFrameState()
  },
  STORE_LIST_IFRAMES(state, iframes) {
    state.iframeList = {
      ...state.iframeList,
      ...iframes.entries
    }
    state.count = iframes.count
    state.next = iframes.next
    state.previous = iframes.previous
    state.results = [...iframes.results]
  },
  STORE_IFRAME_TO_LIST(state, iframe) {
    state.iframeList = {
      ...state.iframeList,
      ...iframe
    }
  },
  STORE_CURRENT_IFRAME_FILES(state, files) {
    state.currentIFrameFiles = files
  },
  CHANGE_FILE_IN_IFRAME(state, payload) {
    const fileChanged = state.currentIFrameFiles[state.currentIFrameFiles.indexOf(payload.file)]
    fileChanged.name = payload.name
  },
  RESET_FILES_IN_IFRAME(state) {
    state.currentIFrameFiles = []
  }
}

export default mutations

